import { emperor } from '~/services';
import { CommentFilterType } from '~/containers/Comments/Comments';

export const addReaction = async (
  commentId: string,
  reactionName: string,
  commentType: CommentFilterType,
  parentCommentId?: string,
  creatorEmail?: string
): Promise<void> => {
  const commentTypeParam =
    commentType === CommentFilterType.GATHERING
      ? 'groupEventComment'
      : 'groupComment';

  await emperor.post('/reaction', {
    commentType: commentTypeParam,
    commentId,
    reactionName,
    ...(parentCommentId ? { parent: parentCommentId } : {}),
    ...(creatorEmail ? { creatorEmail } : {})
  });
};

export const removeReaction = async (
  commentId: string,
  commentType: CommentFilterType,
  parentCommentId?: string
): Promise<void> => {
  const commentTypeParam =
    commentType === CommentFilterType.GATHERING
      ? 'groupEventComment'
      : 'groupComment';

  await emperor.delete('/reaction', {
    params: {
      commentType: commentTypeParam,
      commentId,
      ...(parentCommentId ? { parent: parentCommentId } : {})
    }
  });
};
